import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, formatApiError, TOKEN_KEY } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", f);
      localStorage.setItem(TOKEN_KEY, data.token);
      nav("/admin");
    } catch (ex) {
      setErr(formatApiError(ex));
    } finally {
      setBusy(false);
    }
  };

  const field = "h-12 rounded-xl border-slate-300 bg-white text-slate-900 placeholder:text-slate-400";
  return (
    <div className="grid-lines flex min-h-screen items-center justify-center bg-[#F3F7FF] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 shadow-xl sm:p-10" data-testid="admin-login-form">
        <Logo testId="admin-login-logo" />
        <h1 className="font-display mt-8 flex items-center gap-2 text-2xl font-bold text-slate-900"><Lock className="h-5 w-5 text-blue-600" /> Admin sign in</h1>
        <div className="mt-6 space-y-4">
          <Input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={field} data-testid="admin-email-input" />
          <Input required type="password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={field} data-testid="admin-password-input" />
        </div>
        {err && <p className="mt-4 text-sm font-semibold text-red-600" data-testid="admin-login-error">{err}</p>}
        <button disabled={busy} data-testid="admin-login-button" className="font-display mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-blue-600 py-3.5 text-sm font-bold uppercase text-white disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <a href="/" className="mt-6 block text-center text-sm text-slate-600 hover:text-blue-600" data-testid="admin-back-home">← Back to website</a>
      </form>
    </div>
  );
}
